import { render, staticRenderFns } from "./ghProgress.vue?vue&type=template&id=23765e9e&scoped=true&"
import script from "./ghProgress.vue?vue&type=script&lang=js&"
export * from "./ghProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23765e9e",
  null
  
)

export default component.exports